import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { Route } from 'vue-router';

const namespaced = true;

export interface GlobalState {
	loader: number;
	dataLoaded: boolean;
	hideSubHeader: boolean;
	lastSelectedTabItem: string | null;
	lastRoute: Route | undefined;
}

export const state: GlobalState = {
	loader: 0,
	dataLoaded: false,
	hideSubHeader: false,
	lastSelectedTabItem: null,
	lastRoute: undefined
};

export const mutations: MutationTree<GlobalState> = {
	updateLoader(state: GlobalState, nb: number) {
		state.loader += nb;
		if (state.loader < 0) {
			state.loader = 0;
		}
	},
	reset(state: GlobalState) {
		state.loader = 0;
	},
	updateDataLoaded(state: GlobalState, dataStat: boolean) {
		state.dataLoaded = dataStat;
	},
	updateHideSubHeader(state: GlobalState, hide: boolean) {
		state.hideSubHeader = hide;
	},
	setLastSelectedTabItem(state: GlobalState, tabItem: string) {
		state.lastSelectedTabItem = tabItem;
	},
	updateLastRoute(state: GlobalState, route: Route) {
		state.lastRoute = route;
	}
};

export const actions: ActionTree<GlobalState, RootState> = {
	addLoading(state): void {
		state.commit('updateLoader', 1);
	},
	removeLoading(state): void {
		state.commit('updateLoader', -1);
	},
	resetLoading(state): void {
		state.commit('reset');
	},
	updateDataLoaded(state, dataStat: boolean): void {
		state.commit('updateDataLoaded', dataStat);
	},
	updateHideSubHeader(state, hide: boolean): void {
		state.commit('updateHideSubHeader', hide);
	},
	setLastSelectedTabItem(state, tabItem: string | null) {
		state.commit('setLastSelectedTabItem', tabItem);
	},
	updateLastRoute(state, route: Route) {
		state.commit('updateLastRoute', route);
	}
};

export const getters: GetterTree<GlobalState, RootState> = {
	loading(state): boolean {
		return state.loader > 0;
	},
	hasDataLoaded(state): boolean {
		return state.dataLoaded;
	},
	isHideSubHeader(state): boolean {
		return state.hideSubHeader;
	},
	getLastSelectedTabItem(state): string | null {
		return state.lastSelectedTabItem;
	},
	getLastRoute(state): Route | undefined {
		return state.lastRoute;
	}
};

export const globalState: Module<GlobalState, RootState> = {
	namespaced,
	state,
	actions,
	getters,
	mutations
};
